import awsRumActionNames from '../../consts/aws/awsRumActionNames';
import awsRumActionTypes from '../../consts/aws/awsRumActionTypes';
import awsRumStatusTypes from '../../consts/aws/awsRumStatusTypes';
import pushNotificationTypes from '../../consts/notification/pushNotificationTypes';
import {strCode} from '../../consts/strCode';
import rumCustomEvents from '../../services/events/rumCustomEvents';
import notificationService from '../../services/notificationService';
import uamClientService from '../../services/uam/uamClientService';
import {selectDusnByCodentify} from '../../state/selectors/iotDevices';
import {selectMessageById} from '../../state/selectors/message';
import {setMessages, updateMessageById} from '../../state/slice/message';
import {dispatch, getState} from '../../state/store';
import dateUtils from '../../utils/dateUtils';

const TIMEOUT_FOR_MESSAGE_DELETION = 5_000;

const clearMessages = () => dispatch(setMessages([]));

const readMessage = async (messageId) => {
    const result = await uamClientService.putUpdateUserMessage({messageId, isRead: 'true', isDeleted: 'false'});

    if (!result) return;

    dispatch(updateMessageById({...result}));
};

const removeMessage = (messageId) => {
    pushAnalyticsMessage(messageId, awsRumActionNames.REMOVE);

    markMessageAsDeleted(messageId);

    const timeoutId = setTimeout(async () => {
        const result = await uamClientService.putUpdateUserMessage({messageId, isRead: 'false', isDeleted: 'true'});

        if (result) {
            dispatch(updateMessageById({...result}));
        }
    }, TIMEOUT_FOR_MESSAGE_DELETION);

    notificationService.showUndoRemoveNotification({messageId, timeoutId});
};

const markMessageAsDeleted = async (messageId) => {
    dispatch(updateMessageById({messageId, isDeleted: true}));
};

const undoMessageDeletion = async (messageId) => {
    pushAnalyticsMessage(messageId, awsRumActionNames.RESTORE);

    dispatch(updateMessageById({messageId, isDeleted: false}));
};

const getMessageNameByType = (notificationType) => {
    switch (notificationType) {
        case pushNotificationTypes.FIRMWARE_UPDATE:
            return strCode.MESSAGE_CENTER_PAGE_MESSAGE_NAME_FIRMWARE_UPDATE;
        case pushNotificationTypes.LOYALTY:
            return strCode.MESSAGE_CENTER_PAGE_MESSAGE_NAME_LOYALTY;
        case pushNotificationTypes.INFORMATIVE:
            return strCode.MESSAGE_CENTER_PAGE_MESSAGE_NAME_INFORMATIVE;
        case pushNotificationTypes.MARKETING:
            return strCode.MESSAGE_CENTER_PAGE_MESSAGE_NAME_MARKETING;
        case pushNotificationTypes.CONVERSION:
            return strCode.MESSAGE_CENTER_PAGE_MESSAGE_NAME_CONVERSION;
        case pushNotificationTypes.SYSTEM:
            return strCode.MESSAGE_CENTER_PAGE_MESSAGE_NAME_SYSTEM;
        default:
            return;
    }
};

const pushAnalyticsMessage = (messageId, rumActionName) => {
    const message = selectMessageById(messageId)(getState());

    const {codentify, sentMessageTime, notification} = message;

    const dusn = selectDusnByCodentify(codentify)(getState());

    rumCustomEvents.pushPushNotification({
        dusn,
        startTime: dateUtils.parseDateString(sentMessageTime),
        eventId: messageId,
        destinationType: notification?.destination,
        messageText: notification?.messageText,
        action: awsRumActionTypes.CLICK,
        rumActionName,
        status: awsRumStatusTypes.SUCCESS,
    });
};

export default {
    clearMessages,
    removeMessage,
    readMessage,
    markMessageAsDeleted,
    undoMessageDeletion,
    getMessageNameByType,
};
